<template>
    <section class="section">
        <nav class="level">
            <!-- Left side -->
            <div class="level-left">
                <h3 class="title is-3">Билеты</h3>
            </div>

            <!-- Right side -->
            <div class="level-right">
                <div class="level-item level-left">
                    <b-switch v-model="onlyCurrentOrganization">Только билет организации</b-switch>
                </div>
                <div class="level-item level-left">
                    <router-link class="button is-success" :to="{name: 'education-plan.new'}">Создать</router-link>
                </div>
            </div>
        </nav>


        <b-table
            ref="educationPlanTable"

            :data="educationPlans"

            :per-page="options.perPage"
            :current-page.sync="options.currentPage"
            :pagination-simple="false"
            pagination-position="bottom"
            default-sort-direction="asc"
            sort-icon="chevron-up"
            sort-icon-size="is-small"
            :loading="isLoading"
            :total="paginator.total"
            :backend-filtering="true"
            :backend-sorting="true"
            :backend-pagination="true"
            @filters-change="filterChange"
            @sort="sortChange"

            paginated
            striped
            narrowed
            hoverable
            focusable

            :show-detail-icon="true"
            detailed
            detail-key="id"

            :default-sort="options.sortBy"
            :default-sort-direction="options.sortDirection"
            aria-next-label="Следующая страница"
            aria-previous-label="Предыдущая страница"
            aria-page-label="Страница"
            aria-current-label="Текущая страница"
        >

            <b-table-column field="title" label="Название"  sortable searchable>
                <template #searchable="props">
                    <b-input
                        v-model="props.filters[props.column.field]"
                        placeholder="Поиск..."
                        icon="magnify"
                        size="is-small" />
                </template>
                <template v-slot="props">
                    {{ props.row.title }}
                </template>
            </b-table-column>
            <b-table-column field="organizationId" label="Организация"  sortable>
                <template v-slot="props">
                    <span :title="organizationFullPath(props.row)">{{ organizationName(props.row) }}</span>
                </template>
            </b-table-column>
            <b-table-column field="startDate" label="Дата начала"  sortable searchable>
                <template #searchable="props">
                    <b-datepicker
                        size="is-small"
                        expanded
                        placeholder="03.08.2021"
                        v-model="props.filters[props.column.field]"
                        icon="calendar-today"

                    >
                    </b-datepicker>
                </template>
                <template v-slot="props">
                    {{ props.row.startDate | date }}
                </template>
            </b-table-column>
            <b-table-column field="endDate" label="Дата окончания"  sortable searchable>
                <template #searchable="props">
                    <b-datepicker
                        size="is-small"
                        expanded
                        placeholder="03.08.2021"
                        v-model="props.filters[props.column.field]"
                        icon="calendar-today"

                    >
                    </b-datepicker>
                </template>
                <template v-slot="props">
                    {{ props.row.endDate | date }}
                </template>
            </b-table-column>
            <b-table-column field="positionId" label="Должность" searchable >
                <template #searchable="props">
                    <b-select v-model="props.filters[props.column.field]" style="width: 200px" size="is-small">
                        <option :value="null"> Все </option>
                        <option v-for="item in positions" :value="item.id" :title="item.fullName">{{item.name}}</option>
                    </b-select>
                </template>
                <template v-slot="props">
                    <span :title="positionsNames($_get(props.row, 'positions'), 'fullname')">{{ positionsNames($_get(props.row, 'positions'), 'name') }}</span>
                </template>
            </b-table-column>


            <b-table-column field="action" label="" v-slot="props" >
                <div style="width: 120px" class="buttons is-right" >
                    <b-button title="Посмотреть" @click="openView(props.row.id)" icon-right="record-circle-outline" size="is-small" />
                    <b-button v-if="isCurrentOrganizationOwner(props.row)" title="Поделиться" @click="openShare(props.row.id)" icon-left="share-variant" type="is-info " size="is-small" />
                    <b-button v-if="isCurrentOrganizationOwner(props.row)" title="Редактировать" @click="openEdit(props.row.id)" icon-left="pencil" type="is-success" size="is-small" />
                    <b-button v-if="isCurrentOrganizationOwner(props.row)" title="Удалить" @click="remove(props.row.id)"  icon-left="delete" type="is-danger" size="is-small" />
                </div>
            </b-table-column>

            <template #detail="props">
                <article class="media">
                    {{props.row.description}}
                </article>
            </template>

            <template #empty>
                <div class="has-text-centered">Нет билетов...</div>
            </template>
        </b-table>
        <share-modal :education-plan-id.sync="selectedPlanId" />
        <plan-modal :education-plan-id.sync="visibleEductionPlanId" />
    </section>
</template>
<script>


import { mapActions, mapGetters } from 'vuex'
import { filter, get, includes, map, find, merge } from 'lodash'
import PaginatedFetchMixin from '../../../mixins/PaginatedFetchMixin'
import ContextMixin from '../../../mixins/ContextMixin'
import ShareModal from './Index/ShareModal'
import { STATUS_APPROVED, TYPE_OWNER } from '../../../store/models/share/model'
import PlanModal from './Index/PlanModal'
import { DateTime } from 'luxon'
import OrganizationFetchMixin from '../../../mixins/OrganizationFetchMixin'

export default {
    mixins: [
        PaginatedFetchMixin,
        ContextMixin,
        OrganizationFetchMixin,
    ],
    components: {
        ShareModal,
        PlanModal,
    },
    computed: {
        ...mapGetters({
            educationPlansQuery: 'e/educationPlans/query',
            isLoaderActive: 'e/pages/isLoaderActive',
            positionQuery: 'e/positions/query',
        }),
        positions() {
            return this.positionQuery().orderBy('name').where('parentId', value => !!value).get()
        },
        educationPlans() {
            return this.educationPlansQuery()
                .with(['positions', 'shares.organization'])
                // .where(item => {//не работает сортировка из пагинатора
                //     return includes(this.paginator.ids, item.id)
                // })
                .findIn(this.paginator.ids)
                //.get()
        },
        isLoading() {
            return this.isLoaderActive('educationPlans.fetchItems')
        }
    },
    mounted() {
        let toDay = DateTime.now()

        this.$refs.educationPlanTable.filters = merge({}, this.filters, {
            startDate: toDay.startOf('month').toJSDate(),
            endDate: toDay.toJSDate()
        })

        this.fetchPositions()
        this.fetchOrganizationsIfNeeded()
    },
    methods: {
        ...mapActions({
            fetchItems: 'e/educationPlans/fetchItems',
            fetchOrganizations: 'e/organizations/fetchItems',
            fetchPositions: 'e/positions/fetchItems',
            removeEducationPlans: 'e/educationPlans/remove',
            createEducationPlans: 'e/educationPlans/create',
        }),
        isCurrentOrganizationOwner(item) {
            return filter(item.shares, item =>
                item.organizationId === this.currentOrganizationId &&
                item.status === STATUS_APPROVED &&
                item.type === TYPE_OWNER
            ).length !== 0
        },
        organizationName(item) {
            return get(this.organizationFromShare(item), 'name')
        },
        organizationFullPath(item) {
            let org = this.organizationFromShare(item)
            return org ? org.parentPath() : get(org, 'name')
        },
        organizationFromShare(item) {
            return get(find(item.shares, item =>
                item.status === STATUS_APPROVED &&
                item.type === TYPE_OWNER
            ), 'organization')
        },
        customFilter(filters) {
            let params = {ShareStatus: STATUS_APPROVED}
            if (this.onlyCurrentOrganization) {
                params['organizationId'] = this.currentOrganizationId
                params['ShareType'] = TYPE_OWNER
            }
            if (this.filters.startDate) {
                filters['startDate'] = this.$options.filters.date(this.filters.startDate.toISOString())
            }
            if (this.filters.endDate) {
                filters['endDate'] = this.$options.filters.date(this.filters.endDate.toISOString())
            }
            return merge(params, this.options, this.filters, filters)
        },
        remove(id) {
            this.removeEducationPlans(id)
        },
        openEdit(id) {
            this.$router.push({name: 'education-plan.show', params: {id}})
        },
        openShare(id) {
            this.selectedPlanId = id
        },
        openView(id) {
            this.visibleEductionPlanId = id
        },
        positionsNames(positions, field = 'name') {
            return map(positions, field).join(', ')
        },
        contextChangedHandler() {
            this.fetch()
        }
    },
    data() {
        return {
            selectedPlanId: null,
            onlyCurrentOrganization: false,
            visibleEductionPlanId: null,

            options: {
                currentPage: 1,
                perPage: 20,
                sortDirection: 'desc',
                sortBy: 'startDate',
            },
        }
    },
    watch: {
        onlyCurrentOrganization() {
            this.fetch()
        }
    }
}
</script>